<template>
    <div>
        <div class="row"
             style="margin-bottom: 0;">
            <div class="col s12 offset-m2 m8 offset-l2 l8 offset-xl2 xl8">
                <h5 class="center-align white-text">
                    Камеры пользователя "{{$route.params.login}}"
                </h5>
                <div class="row"
                     style="margin-bottom: 0;">
                    <div class="input-field col s12 m8 l8 xl8" style="visibility: hidden">
                        <input id="first_name2"
                               type="text"
                               @keyup="search($event)"
                               class="white-text">
                        <label class="white-text"
                               for="first_name2">Search</label>
                    </div>
                    <div class="col s12 m4 l4 xl4 main" v-if="$route.params.type !== 'bugs'">
                        <router-link
                                :to="{ name: 'add-cameras', params: {login: $route.params.login } }"
                                class="waves-effect waves-light btn indigo darken-3 btn-small"
                                style="width: 100%;"
                        >
                            <i class="material-icons left">add</i>
                            новая камера
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col s12 offset-m2 m8 offset-l2 l8 offset-xl2 xl8">
                <table class="highlight card bg centered">
                    <thead>
                    <tr>
                        <th>имя</th>
                        <th>название</th>
                        <th class="hide-on-small-and-down">серийный номер</th>
                        <th class="hide-on-small-and-down">глубина dvr</th>
                        <th class="hide-on-small-and-down">доступ</th>
                        <th class="hide-on-small-and-down">включена</th>
                        <th class="hide-on-small-and-down">текущий статус</th>
                        <th>видео</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr :key="camera.id"
                        data-id="cameras"
                        :data-search="camera.name"
                        @click="getCamera(camera.name)"
                        v-for="camera in cameras">
                        <td>{{camera.name}}</td>
                        <td>{{camera.title}}</td>
                        <td>{{camera.agent_serial}}</td>
                        <td>{{camera.dvr_depth}}</td>
                        <td>{{camera.access}}</td>
                        <td class="hide-on-small-and-down">
                            <i class="material-icons  darken-3"
                               :class="camera.enabled ?  'green-text' : 'red-text'">
                                {{camera.enabled ? "check_circle_outline" : "highlight_off"}}
                            </i>
                        </td>
                        <td class="hide-on-small-and-down">
                            <i class="material-icons  darken-3"
                               :class="camera.online ?  'green-text' : 'red-text'">
                                {{camera.online ? "check_circle_outline" : "highlight_off"}}
                            </i>
                        </td>
                        <td>
                            <div class="btn indigo right waves-effect waves-light tooltips"
                                 data-tooltip="камеры пользователя"
                                 style="height: 30px;"
                                 v-if="camera.online"
                                 @click.stop="$router.push(`/cameras/video/${camera.name}`)">
                                <i class="material-icons"
                                   style="position:relative; top: -2px;">play_arrow</i>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>

    import {mapState, mapMutations} from "vuex";
    import {eventEmitter} from "../../main";
    import setRules from "../../assets/setRules";

    import Cameras from "../../plugins/controllers/cameras";

    export default {
        name: "UsersCameras",
        data() {
            return {
                cameras: []
            };
        },
        methods: {
            getApiData() {
                Cameras.getCamerasListByLogin(this.$route.params.login).then((response) => {
                    setRules(response);
                    console.log(response.data);
                    this.cameras = response.data;
                }).catch((error) => {
                    console.log(error)
                })
            },
            getCamera(name) {
                this.$router.push(`/cameras/edit/${this.$route.params.login}/${this.$route.params.type}/${name}`);
            },
            deleteCamera(name) {
                console.log(name);
                return null;
            },
        },
        computed: {
            ...mapState(["tokenSuccess", "showLargePopup"]),

        },
        beforeMount() {
            eventEmitter.$once("tokenSuccess", this.getApiData);
        },
        beforeDestroy() {
            if (this.e) {
                this.e.forEach(el => {
                    el.destroy();
                });
            }
            eventEmitter.$off("tokenSuccess", this.getApiData);
        },
        mounted() {
            if (this.tokenSuccess) {
                this.getApiData();
            } else {
                console.log("token is not success");
            }
            // preload.show();
        },
        watch: {
            '$route'(to, from) {
                if (this.tokenSuccess) {

                    console.log(localStorage.getItem("login"));
                    console.log(this.$route.params);

                    this.getApiData();

                } else {
                    console.log("token is not success");
                }
            }
        }
    }
</script>


<style scoped>
    .bold {
        font-weight: 500;
    }

    .main {
        margin-top: 15px;
    }

    @media screen and (max-width: 600px) {
        .main {
            margin: 0;
        }

        h5 {
            font-size: 16px;
            margin-bottom: 0;
        }
    }

    input[type=text]:not(.browser-default) {
        border-bottom: 1px solid #d0d0d0;
        box-shadow: 0 1px 0 #d0d0d0;
    }

    input[type="text"]:not(.browser-default):focus:not([readonly]) {
        border-bottom: 1px solid #f0e8f1;
        box-shadow: 0 1px 0 #dfd8df;
    }

    label.white-text {
        color: #d0d0d0 !important;

    &
    .active {
        color: #fff !important;
    }

    }

    .hidden {
        display: none;
    }

    input[type="text"] {

    &
    :not(.browser-default):focus:not([readonly]) + label {
        color: #fff;
    }

    }

    .bg {
        background-color: rgba(56, 56, 56, 0.8);
    }

    [type="checkbox"]:checked + span:not(.lever):before {
        border: 2px solid transparent;
        border-right-color: white;
        border-bottom-color: white;
    }

    [type="checkbox"] + span:not(.lever):before {
        border: 2px solid white;
    }

    table.highlight > tbody > tr > td {
        padding: 7px 10px;
        font-size: 14px;
    }

    table.highlight > tbody > tr:hover {
        background-color: rgba(36, 37, 40, 0.51);
    }

    tr {
        cursor: pointer;
    }

    tr th {
        cursor: default;
    }

    tr td:first-child {
        font-weight: 600;
        text-transform: uppercase;
    }

    tr td:last-child {
        text-align: center;
    }

</style>